import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

// Thunks
export const getSecurityEvents = createAsyncThunk('security/getSecurityEvents', async (params = {}, { rejectWithValue }) => {
    try {
        const { data } = await api.get('/admin/security/events', { params })
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Hadisələr yüklənə bilmədi')
    }
})

export const getBlockedIps = createAsyncThunk('security/getBlockedIps', async (params = {}, { rejectWithValue }) => {
    try {
        const { data } = await api.get('/admin/security/blocked-ips', { params })
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Bloklanmış IP-lər yüklənə bilmədi')
    }
})

export const blockIp = createAsyncThunk('security/blockIp', async (payload, { rejectWithValue }) => {
    try {
        const { data } = await api.post('/admin/security/block-ip', payload)
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'IP bloklana bilmədi')
    }
})

export const unblockIp = createAsyncThunk('security/unblockIp', async (id, { rejectWithValue }) => {
    try {
        const { data } = await api.post(`/admin/security/unblock-ip/${id}`)
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'IP bloku götürülə bilmədi')
    }
})

export const getBlockedAccounts = createAsyncThunk('security/getBlockedAccounts', async (params = {}, { rejectWithValue }) => {
    try {
        const { data } = await api.get('/admin/security/blocked-accounts', { params })
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Məhdudiyyətlər yüklənə bilmədi')
    }
})

export const blockAccount = createAsyncThunk('security/blockAccount', async (payload, { rejectWithValue }) => {
    try {
        const { data } = await api.post('/admin/security/block-account', payload)
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Hesab məhdudlaşdırıla bilmədi')
    }
})

export const unblockAccount = createAsyncThunk('security/unblockAccount', async (id, { rejectWithValue }) => {
    try {
        const { data } = await api.post(`/admin/security/unblock-account/${id}`)
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Məhdudiyyət götürülə bilmədi')
    }
})

export const ipLookup = createAsyncThunk('security/ipLookup', async (ip, { rejectWithValue }) => {
    try {
        const { data } = await api.get('/admin/security/ip-lookup', { params: { ip } })
        return data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'IP lookup uğursuz oldu')
    }
})

// Slice
const securitySlice = createSlice({
    name: 'security',
    initialState: {
        events: [],
        totalEvents: 0,
        blockedIps: [],
        totalBlockedIps: 0,
        blockedAccounts: [],
        totalBlockedAccounts: 0,
        ipLookupResult: null,
        loader: false,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        },
        clearIpLookup: (state) => {
            state.ipLookupResult = null
        }
    },
    extraReducers: (builder) => {
        const pending = (state) => { state.loader = true }
        const fail = (state, action) => {
            state.loader = false
            state.errorMessage = action.payload
        }

        builder
            .addCase(getSecurityEvents.pending, pending)
            .addCase(getSecurityEvents.fulfilled, (state, action) => {
                state.loader = false
                state.events = action.payload.events || []
                state.totalEvents = action.payload.total || 0
            })
            .addCase(getSecurityEvents.rejected, fail)

            .addCase(getBlockedIps.pending, pending)
            .addCase(getBlockedIps.fulfilled, (state, action) => {
                state.loader = false
                state.blockedIps = action.payload.blockedIps || []
                state.totalBlockedIps = action.payload.total || 0
            })
            .addCase(getBlockedIps.rejected, fail)

            .addCase(blockIp.fulfilled, (state, action) => {
                state.successMessage = action.payload.message
            })
            .addCase(blockIp.rejected, fail)

            .addCase(unblockIp.fulfilled, (state, action) => {
                state.successMessage = action.payload.message
            })
            .addCase(unblockIp.rejected, fail)

            .addCase(getBlockedAccounts.pending, pending)
            .addCase(getBlockedAccounts.fulfilled, (state, action) => {
                state.loader = false
                state.blockedAccounts = action.payload.restrictions || []
                state.totalBlockedAccounts = action.payload.total || 0
            })
            .addCase(getBlockedAccounts.rejected, fail)

            .addCase(blockAccount.fulfilled, (state, action) => {
                state.successMessage = action.payload.message
            })
            .addCase(blockAccount.rejected, fail)

            .addCase(unblockAccount.fulfilled, (state, action) => {
                state.successMessage = action.payload.message
            })
            .addCase(unblockAccount.rejected, fail)

            .addCase(ipLookup.pending, pending)
            .addCase(ipLookup.fulfilled, (state, action) => {
                state.loader = false
                state.ipLookupResult = action.payload
            })
            .addCase(ipLookup.rejected, fail)
    }
})

export const { messageClear, clearIpLookup } = securitySlice.actions
export default securitySlice.reducer
